export default __webpack_public_path__ + "static/media/700.c68a081c.png";